import {TableColumnData} from "../../../../types/common";
import React, {useMemo} from "react";
import {OrganManagerShareDTO} from "../../../../types/organShare";

export function useOrganManagerShareColumns() {

    const managerName: TableColumnData<OrganManagerShareDTO> = useMemo(
        () => ({
            accessor: "managerName",
            header: "소속 관리자",
            sortable: false,
            getNode: (vo: OrganManagerShareDTO) => <span>{vo.managerName}</span>,
        }), []);

    const emailColumn: TableColumnData<OrganManagerShareDTO> = useMemo(
        () => ({
            accessor: "email",
            header: "소속 관리자 아이디",
            sortable: false,
            getNode: (vo: OrganManagerShareDTO) => <span>{vo.email}</span>,
        }), []);


    const managerPhoneNumberColumn: TableColumnData<OrganManagerShareDTO> = useMemo(
        () => ({
            accessor: "phoneNumber",
            header: "소속 관리자 전화번호",
            sortable: false,
            getNode: (vo: OrganManagerShareDTO) => <span>{`(${vo.codePhone}) ${vo.phoneNumber}`}</span>,
        }), []);

    const columns: TableColumnData<OrganManagerShareDTO>[] = useMemo(
        () => [
            managerName,
            emailColumn,
            managerPhoneNumberColumn,
        ],
        [
            managerName,
            emailColumn,
            managerPhoneNumberColumn,
        ]
    );


    return {
        columns,
    };
}